import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../Dashboard/Invoice/Invoice.css";
import { useLocation } from "react-router-dom";
import TableComponent from "../Dashboard/Invoice/BankDepositTable";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../common/ToastHandler";

function AddBankDeposite() {
  const { user } = useContext(AuthContext);
  const { Get, Post ,} = useApi();
  const storeid = user.store;
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("");
  const today = new Date().toISOString().split("T")[0]; 
  const [, setIsOpen] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [banks, setBanks] = useState([]);
  const location = useLocation();
  const {handleToast} = useToastHandler()
  useEffect(() => {
    setActiveButton(location.pathname); 
  }, [location.pathname]);

  const dropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    date: "" || today,
    transaction_type: "Bank Deposit",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    total_amount: "",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: null,
    owner: null,
  });

  const makeBlank = () => {
    setFormData({
      date: "" || today,
      transaction_type: "Bank Deposit",
      bank: "",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      total_amount: "",
      note: "",
      atm_commission: "",
      income_type: null,
      bank_deposite_type: null,
      owner: null,
    });
  };

  const handleCancel = () => {
    makeBlank();
  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const data = await Get("bank");
        setBanks(data);
      } catch (error) {
        console.error("Error fetching banks:", error);
        handleToast({
          type:'ERROR',
          message:"Error fetching banks:" + error
        })
      }
    };

    fetchBanks();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    setIsOpen(false); 
    navigate(path); 
    setActiveButton(path);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cash_amount" || name === "cheque_amount") {

      if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {

      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bank_deposite_type || formData.bank_deposite_type === "") {

      handleToast({
        type:'ERROR',
        message:"Please select a valid Deposite type."
      })
      return; 
    }

    try {
      const updatedFormData = { ...formData, store: storeid };
      console.log("Submitting data:", updatedFormData); 

      const response = await Post("transactionData", updatedFormData);

      if (response && (response.status === 200 || response.status === 201)) {

        handleToast({
          type:'SUCCESS',
          message:"Submission successful!"
        })

        setFormData({
          date: today,
          transaction_type: "Bank Deposit",
          bank: "",
          amount: "",
          cash_amount: "",
          cheque_amount: "",
          total_amount: "",
          note: "",
          atm_commission: "",
          income_type: null,
          bank_deposite_type: null,
          owner: null,
        });

        setReloadData(!reloadData); 

        setIsOpen(false);
      } else {
        setReloadData(!reloadData);

        throw new Error(`Error: ${response.statusText || "Unknown error"}`); 
      }
    } catch (error) {
      setReloadData(!reloadData);
      console.error("Error submitting form:", error); 

      handleToast({
        type:'ERROR',
      message: `Submission failed: ${error.message}`
      })
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer />
      <div className="d-flex justify-content-between mb-4">
        <div className="button-groups">
          <button
            className={`btn ${activeButton === "/atm-invoice" ? "active" : ""}`}
            onClick={() => handleLinkClick("/atm-invoice")}
          >
            ATM Deposit
          </button>

          <button
            className={`btn ${
              activeButton === "/bank-invoice" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/bank-invoice")}
          >
            Bank Deposit
          </button>
        </div>
      </div>
      <div className="formcontainer">
        <div
          className="container"
          style={{
            backgroundColor: "white",
            border: "1px solid #EBEAF2",
            boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
            borderRadius: "40px",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div
              className="col-md-12 row "
              style={{
                gap: "4%",
                marginLeft: "3px",
              }}
            >
              <div className=" col-md-3">
                <input
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  type="date"
                  className="form-control-borderless"
                  name="date"
                  value={formData.date || today}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3 col-md-4">
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  className="input-select"
                  id="bank_deposite_type"
                  name="bank_deposite_type"
                  value={formData.bank_deposite_type}
                  onChange={handleChange}

                >
                  <option value="" enable>
                    Select Cash type
                  </option>
                  {["Business cash", "Lottery cash", "Gas cash"].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3 col-md-4">
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  className="input-select"
                  name="bank"
                  value={formData.bank}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a bank</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", 
                  gap: "50px", 
                }}
              >
                <div
                  className="form-group col-3"
                  style={{
                    display: "flex",
                    alignItems: "center",

                    flex: "1", 
                  }}
                >
                  <div
                    className="input-group"
                    style={{ position: "relative", marginTop: "19px" }}
                  >
                    <input
                      type="text"

                      className="form-control-invoice"
                      name="cash_amount"
                      placeholder=""
                      value={formData.cash_amount || ""}
                      onChange={handleChange}
                      maxLength={10}
                    />
                    <label
                      htmlFor="cash_amount"
                      className="floating-label-invoice"
                    >
                      Cash Amount
                    </label>
                  </div>
                </div>

                <div
                  className="form-group  "
                  style={{
                    display: "flex",

                    flex: "1",
                  }}
                >
                  <div
                    className="input-group"
                    style={{ position: "relative", marginTop: "19px" }}
                  >
                    <input
                      type="number"

                      className="form-control-invoice"
                      name="cheque_amount"
                      placeholder=""
                      value={formData.cheque_amount}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="cheque_amount"
                      className="floating-label-invoice"
                    >
                      Cheque Amount
                    </label>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "none",
                    height: "50px",
                    flex: "1",
                  }}
                ></div>
              </div>
            </div>

            <div className="d-flex justify-content-end" style={{ gap: "15px" }}>
              <button
                type="button"
                className="btn btn-contained me-2"
                onClick={handleCancel}
                style={{
                  border: " 1px solid #282e26",
                  borderRadius: "20px",
                  width: "150px",
                  height: "38px",
                  fontWeight: "bold",
                }}
              >
                Clear
              </button>
              <button
                type="submit"
                className="btn"
                style={{
                  color: "white",
                  backgroundColor: "#282e26",
                  borderRadius: "40px",
                  width: "150px",
                  height: "38px",
                  fontWeight: "bold",
                }}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        className="container mt-5"
        style={{
          backgroundColor: "white",
          boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
          border: "1px solid #EBEAF2",
        }}
      >
        <TableComponent reloadData={reloadData} />
      </div>
    </div>
  );
}

export default AddBankDeposite;